export default "__VITE_ASSET__ac11417b__"